module.exports = __webpack_public_path__ + "static/media/currency-name-symbol.d6cb315b.png";